import { getMessageForErrorCode } from "../../util/error-message-mapper";
import { CloudGovErrorCodeLiterals } from "../api-error";
import { matchType } from "../base/base-type";

const ChangeAuthMethodErrorCodes = [
  "org_user_with_same_email_already_exists",
  "org_user_has_not_email",
  "sending_mail_error",
  "external_user_id_already_used",
] as const;
type ChangeAuthMethodErrorCodesLiterals =
  (typeof ChangeAuthMethodErrorCodes)[number];

// 認証方式切り替えに関するエラーコードに基づいたエラーメッセージを取得する
export const toErrorMessageForChangeAuthMethod = (
  code: ChangeAuthMethodErrorCodesLiterals | string,
) => {
  const err = matchType<ChangeAuthMethodErrorCodesLiterals | string, string>(
    code,
    {
      org_user_with_same_email_already_exists:
        "既に同じメールアドレスを持つユーザーが存在するため、仮パスワードを送信できません。別のメールアドレスを設定してください。",
      org_user_has_not_email: "ユーザーにメールアドレスが登録されていません。",
      sending_mail_error: "仮パスワードのメール送信に失敗しました。",
      external_user_id_already_used:
        "指定された外部ユーザーIDは既に使用されています。",
    },
  );

  if (err) {
    return err;
  }

  // 想定できないエラーの場合のフォールバック
  return getMessageForErrorCode(code as CloudGovErrorCodeLiterals);
};
